import React from 'react';
import './StatCard.css';

export const StatCard = ({ label, value, trend }: { label: string, value: string | number, trend?: string }) => (
  <div className="stat-card">
    <div className="stat-card-content">
      <span className="stat-card-label">{label}</span>
      <div className="stat-card-value-container">
        <span className="stat-card-value">{value}</span>
        {trend && <span className="stat-card-trend">{trend}</span>}
      </div>
    </div>
    <div className="stat-card-bar-container">
      <div className="stat-card-bar-fill" />
    </div>
  </div>
);
